import { 
    FETCH_RESOURCES,
    FETCH_RESOURCES_BY_GROUP,
    FETCH_RESOURCE_CATEGORIES,
    CREATE_RESOURCE 
} from '../constants/actionTypes';

const initialState = {
    resources: [],
    categories: [],
    loading: true,
    error: null
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_RESOURCES:
            return {
                ...state,
                resources: action.payload,
                loading: false
            };
        case FETCH_RESOURCES_BY_GROUP:
            return {
                ...state,
                resources: action.payload,
                loading: false
            };
        case FETCH_RESOURCE_CATEGORIES:
            return {
                ...state,
                categories: action.payload,
                loading: false
            };
        case CREATE_RESOURCE:
            return {
                ...state,
                resources: [...state.resources, action.payload]
            };
        default:
            return state;
    }
}; 